module.exports = __webpack_public_path__ + "img/Wp_2070.183ec738.png";